export default "__VITE_ASSET__rRQ6Y3T8vZXU9nuHPuKfFQ__"